import request from '@/utils/request'

const prefix = '/v2/bi'

export default {
  getChartConfigList (params) {
    return request.get(`${prefix}/data-chart-config/`, { params })
  }
}
